import { Controller } from '@hotwired/stimulus';
const html2canvas = require('html2canvas');

export default class extends Controller {
  static targets = ['dialog', 'logicModel'];

  dialogTargetConnected() {
    this.dialog = document.querySelector('ion-modal#export-dialog');
  }

  openDialog() {
    this.dialog.isOpen = true;
  }

  modelScreenshotPng() {
    html2canvas(this.logicModelTarget).then((canvas) => {
      const base64img = canvas.toDataURL('image/png');
      let a = document.createElement('a');
      a.download = 'irlm-model.png';
      a.href = base64img;
      a.click();
    });
  }

  modelScreenshotJpeg() {
    html2canvas(this.logicModelTarget).then((canvas) => {
      const base64img = canvas.toDataURL('image/jpeg');
      let a = document.createElement('a');
      a.download = 'irlm-model.jpg';
      a.href = base64img;
      a.click();
    });
  }

  disableLink(event) {
    event.target.setAttribute('disabled', 'disabled');
  }
}
